<template>
	<div class="advanced-app-banner-container" :class="'advanced-app-banner-container__'+currentLayoutClass" style="" v-if="showAdvancedBanner">
		<table class="advanced-app-banner" :class="'advanced-app-banner__'+currentLayoutClass"
					 style="">
			<tr>
				<td>
					<img
						class="advanced-app-banner__icon"
						v-bind:src="image"
					/>
				</td>
				<td>
					<p class="advanced-app-banner__text">
						<span class="advanced-app-banner__text__title">{{title}}</span>
						<span class="advanced-app-banner__text__desc"
						>{{message}}</span
						>
					</p>
				</td>
				<td style="text-align: right"  v-if="dismissable">
				<span class="advanced-app-banner__close" @click="closeBasicBanner">&times;</span>
				</td>
			</tr>
			<tr>
				<td></td>
				<td colspan="2" class="advanced-app-banner__cta__container">
					<button class="advanced-app-banner__cta" @click="
						closeBasicBanner();
						close();
						$emit('click', actionUrl);
					">
						{{actionLabel}}
					</button>
				</td>
			</tr>
		</table>
	</div>

	<div class="advanced-app-banner-container" :class="currentLayoutClass"  style=""  v-else-if="showConfirm">
		<table class="advanced-app-banner"
			style="padding: 2px 15px !important"		>
			<tr>
				<td>
					<p class="advanced-app-banner__text">
					<span class="advanced-app-banner__text__desc"
					>See this notification again?</span
					>
					</p>
				</td>
				<td class="advanced-app-banner__cta__container">
					<button class="advanced-app-banner__cta" @click="confirm(true)">
						Yes
					</button>
					<button class="advanced-app-banner__cta" @click="confirm(false)">
						No
					</button>
				</td>
			</tr>
		</table>
	</div>

	<div class="advanced-app-banner-container" :class="currentLayoutClass" style=""  v-else-if="showBasicBanner">
		<table
			class="advanced-app-banner"
			style="padding: 2px 15px !important"
		>
			<tr>
				<td>
					<p class="advanced-app-banner__text">
						<span class="advanced-app-banner__text__title">{{title}}</span>
						<span class="advanced-app-banner__text__desc"
						>{{message}}</span
						>
					</p>
				</td>
				<td class="advanced-app-banner__cta__container">
					<button class="advanced-app-banner__cta" @click="
						closeBasicBanner();
						close();
						$emit('click', actionUrl);
					">
						{{actionLabel}}
					</button>
				</td>
				<td style="text-align: right" v-if="dismissable">
				<span class="advanced-app-banner__close" @click="closeBasicBanner"
				>&times;</span
				>
				</td>
			</tr>
		</table>
	</div>
</template>
<script>
export default {
	name: "notification-banner",

	props: {
		dismissable:{
			type: Boolean,
			default: false
		},
		title:{
			type: String,
			default: ""
		},
		message:{
			type: String,
			default: ""
		},
		advanced:{
			type: Boolean,
			default: false
		},
		basic:{
			type: Boolean,
			default: false
		},
		image:{
			type: String
		},
		actionLabel:{
			type: String
		},
		actionUrl:{
			type: String
		},
		name:{
			type: String
		},
		confirmDismissForever:{
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showBasicBanner: false,
			showAdvancedBanner: false,
			showConfirm: false,
			localStorageKeyPrefix: 'showNotificationBanner',
			currentLayoutClass: ''
		};
	},
	methods: {
		initBanner() {
			let localStorageKey = this.localStorageKeyPrefix + this.name;


			if (localStorage.hasOwnProperty(localStorageKey) === true) {
				if(localStorage.getItem(localStorageKey) === true){
					this.showBasicBanner = this.basic;
					this.showAdvancedBanner = this.advanced;
				}
			}else{
				this.showBasicBanner = this.basic;
				this.showAdvancedBanner = this.advanced;
			}
		},
		closeBasicBanner() {
			if(this.confirmDismissForever){
				this.showConfirm = true;
			}
			this.showBasicBanner = false;
			this.showAdvancedBanner = false;
		},
		close() {
			if(this.confirmDismissForever){
				this.showConfirm = true;
			}
			this.showAdvancedBanner = false;
			this.showBasicBanner = false;
		},

		confirm(s) {

			let localStorageKey = this.localStorageKeyPrefix + this.name;
			if (s === true) {
				localStorage.setItem(localStorageKey, JSON.stringify(true));

				this.showAdvancedBanner = false;
				this.showBasicBanner = false;
				this.showConfirm = false;
			} else {
				localStorage.setItem(localStorageKey, JSON.stringify(false));

				this.showAdvancedBanner = false;
				this.showBasicBanner = false;
				this.showConfirm = false;


				if(localStorage.hasOwnProperty('notification-banner-message') === true) {
					localStorage.removeItem('notification-banner-message');
				}
			}
		},
	},
	mounted() {
		this.currentLayoutClass = this.$store.getters.layout.toLowerCase();
		this.initBanner();
	},
};
</script>
<style lang="scss">
.advanced-app-banner {
	&-container{
		width:100%;
		border-top: 0.25px solid var(--light-black);
		padding-right: 10px;
		position: fixed;
		background: var(--light-gray);
		z-index: 10000;
		display: flex;
		align-items: center;
		justify-content: center;

		&__mobile{
			bottom:48px;
			height:135px;
		}
		&__desktop{
			bottom:0px;
			height:100px;
		}
	}
	max-width: var(--app-width);
	min-width: 320px;
	overflow-x: auto;
	background: var(--light-gray);
	color: var(--black);
	width: 100%;

	&__mobile{
		padding: 2px 5px;
	}
	&__desktop{
		padding: 2px 15px;
	}

	&__close {
		font-size: 1.5rem;
		cursor: pointer;
		vertical-align: top;
	}
	&__icon {
		height: 40px;
		width: 40px;
		border-radius: 5px;
		cursor: pointer;
		vertical-align: middle;
	}
	&__text {
		margin: 0;
		cursor: pointer;
		vertical-align: middle;
		&__title {
			display: block;
			font-size: 1.1rem;
			text-transform: uppercase;
			font-weight: var(--font-weight-medium);
		}
		&__desc {
			display: block;
			font-size: 0.8rem;
			line-height: 1.7em;
			font-weight: var(--font-weight-normal);
		}
	}
	&__cta {
		background: #629a22;
		border: none;
		font-size: 0.8rem;
		font-weight: var(--font-weight-medium);
		color: var(--always-white);
		padding: 5px 10px;
		border-radius: 5px;
		cursor: pointer;
		vertical-align: middle;
		&__container {
			text-align: right;
		}
	}
}
</style>
